import { consultationStatus } from "../groq/queries";
import { getClient } from "../lib/sanityClient";
import { getApiClient } from "../lib/apiClient";

export const matchDldAreas = async ({ areas = [] }) =>
  getApiClient().get({
    url: "/api/common/match_dld_areas",
    query: {
      areas,
    },
  });

export const collect = async ({
  name,
  email,
  phone,
  project,
  developer,
  url,
  type,
  lang,
  ref,
  meta,
  notes,
  referrer,
}) => {
  return getApiClient().post(
    {
      name,
      email,
      phone,
      project,
      developer,
      url,
      type,
      lang,
      ref,
      meta,
      notes,
      referrer,
    },
    "/api/collect",
  );
};

export const fetchConsultationStatus = async () => {
  return await getClient().fetch(consultationStatus);
};

export const fetchCurrencies = async () => {
  return getApiClient({ baseUrl: "https://api.currencyapi.com" })
    .options({
      // https://github.com/elbywan/wretch/issues/203
      next: {
        revalidate: 86000,
        tags: ["currencies"],
      },
    })
    .get(
      `/v3/latest?apikey=${process.env.CURRENCYAPI_KEY}&base_currency=AED&currencies=EUR,USD,GBP,RUB,BYN,CNY,CHF,PKR,INR,CAD`,
    );
};
